(function () {
  const SLIDE_MS = 300;

  const toggleItem = ($toggle) => {
    const $item = $toggle.parent();
    const $container = $toggle.closest(".collapsible-content__items");
    const $answer = $toggle.next();
    const isActive = $item.hasClass("active");

    // Close all items in this group
    $container.find(".collapsible-content__item.active").removeClass("active");
    $container.find(".collapsible-content__answer").stop().slideUp(SLIDE_MS);
    $container.find(".collapsible-content__toggle").attr("aria-expanded", "false");

    // Open the clicked one if it was closed
    if (!isActive) {
      $item.addClass("active");
      $answer.stop().slideDown(SLIDE_MS);
      $toggle.attr("aria-expanded", "true");
    }
  };

  const initCollapsibleContent = () => {
    const $toggles = $(".collapsible-content__toggle");
    if (!$toggles.length) return;

    // Initial ARIA state + focusability for non-button toggles
    $toggles.each(function () {
      const $toggle = $(this);
      $toggle.attr(
        "aria-expanded",
        $toggle.parent().hasClass("active") ? "true" : "false"
      );

      if (!$toggle.is("button")) {
        $toggle.attr({ role: "button", tabindex: "0" });
      }
    });

    // Namespaced events so re-init on section:load doesn't stack handlers
    $toggles
      .off(".collapsible")
      .on("click.collapsible", function () {
        toggleItem($(this));
      })
      .on("keydown.collapsible", function (event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault(); // stops the native click and page scroll
          toggleItem($(this));
        }
      });
  };

  document.addEventListener("shopify:section:load", initCollapsibleContent);
  initCollapsibleContent();
})();

/* old script witout keyboard event ============

(function () {
	const initCollapsibleContent = () => {
		$(".collapsible-content__toggle").unbind("click").on("click", function () {
			const parent = $(this).parent();

			if (!parent.hasClass("active")) {
				parent
					.siblings(".collapsible-content__item.active")
					.removeClass("active");
				parent.addClass("active");
				$(this)
					.closest(".collapsible-content__items")
					.find(".collapsible-content__answer")
					.stop()
					.slideUp(300);
				$(this).next().stop().slideDown(300);
			} else {
				parent
					.siblings(".collapsible-content__item.active")
					.removeClass("active");
				parent
					.closest(".collapsible-content__items")
					.find(".collapsible-content__answer")
					.stop()
					.slideUp(300);
				parent.removeClass("active");
				$(this).next().stop().slideUp(300);
			}
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initCollapsibleContent();
	});

	initCollapsibleContent();
})();
*/